<template>
  <div style="display: inline;">
    <template v-for="(node, index) in parsedContent">
      <section :key="index" style="display: inline-block;">
        <el-tooltip
          v-if="node.type === 'tooltip'"
          class="item"
          effect="dark"
          placement="top"
        >
          <section slot="content" class="table-tip-wrap">
            <!-- 扫描网点 -->
            <ul v-if="node.comType === 'scanNetwork'" class="table-tip">
              <li class="table-row">
                <span class="table-col">网点客服：{{ formatData.customerServicePrincipal }}</span>
              </li>
              <li class="table-row">
                <span class="table-col">联系方式：{{ formatData.customerServiceTelephone }}</span>
              </li>
              <!-- <template v-if="node.exceptionClass">
                <li class="table-row">
                  <span class="table-col">异常类型：{{ formatData.abnormalTypeName }}</span>
                </li>
                <li class="table-row">
                  <span class="table-col">异常原因：{{ formatData.abnormalCauses }}</span>
                </li>
                <li class="table-row">
                  <span class="table-col">应对话术：{{ formatData.speechcraft }}</span>
                </li>
                <li class="table-row">
                  <span class="table-col">异常解决方案：{{ formatData.solution }}</span>
                </li>
              </template> -->
            </ul>
            <!-- 下一站网点 -->
            <ul v-if="node.comType === 'nextStop'" class="table-tip">
              <li class="table-row">
                <span class="table-col">网点客服：{{ formatData.showNetLast && formatData.showNetLast.customerServicePrincipal }}</span>
              </li>
              <li class="table-row">
                <span class="table-col">联系方式：{{ formatData.showNetLast && formatData.showNetLast.customerServiceTelephone }}</span>
              </li>
              <!-- <template v-if="node.exceptionClass">
                <li class="table-row">
                  <span class="table-col">异常类型：{{ formatData.showNetLast && formatData.showNetLast.abnormalTypeName }}</span>
                </li>
                <li class="table-row">
                  <span class="table-col">异常原因：{{ formatData.showNetLast && formatData.showNetLast.abnormalCauses }}</span>
                </li>
                <li class="table-row">
                  <span class="table-col">应对话术：{{ formatData.showNetLast && formatData.showNetLast.speechcraft }}</span>
                </li>
                <li class="table-row">
                  <span class="table-col">异常解决方案：{{ formatData.showNetLast && formatData.showNetLast.solution }}</span>
                </li>
              </template> -->
            </ul>
            <!-- 包号 -->
            <ul v-else-if="node.comType === 'package'" class="table-tip is-border-table">
              <li class="table-row">
                <span class="table-col">建包名称</span>
                <span class="table-col">包内件总数</span>
              </li>
              <li class="table-row">
                <span class="table-col">{{ formatData.packageName }}</span>
                <span class="table-col">{{ formatData.packageTotalCount }}</span>
              </li>
            </ul>
            <!-- 任务号 -->
            <ul v-else-if="node.comType === 'task'" class="table-tip is-border-table">
              <!-- 任务信息 -->
              <template v-if="option.abnormalTask">
                <li class="table-row">
                  <!-- 任务异常信息 -->
                  <template v-if="node.exceptionClass">
                    <span class="table-col">异常类型</span>
                    <span class="table-col">持续时长</span>
                  </template>
                  <span class="table-col">规划到达时间</span>
                  <span class="table-col">预计到达时间</span>
                  <span class="table-col">任务状态</span>
                  <span class="table-col">实际到达时间</span>
                </li>
                <li class="table-row">
                  <!-- 任务异常信息 -->
                  <template v-if="node.exceptionClass">
                    <span class="table-col table-inner-cell">
                      <div v-for="(v, i) in formatData.taskList" :key="`exceptionType-${i}`" >{{ v.exceptionType || '-' }}</div>
                    </span>
                    <span class="table-col table-inner-cell">
                      <div v-for="(v, i) in formatData.taskList" :key="`duration-${i}`" >{{ v.duration || '-' }}</div>
                    </span>
                  </template>
                  <span class="table-col">{{ formatData.plannedArrivalTime }}</span>
                  <span class="table-col">{{ formatData.predictArrivalTime }}</span>
                  <span class="table-col">{{ formatData.shipmentStateDesc }}</span>
                  <span class="table-col">{{ formatData.actualArrivalTime }}</span>
                </li>
              </template>
              <!-- 经停信息 -->
              <template v-else>
                <li class="table-row">
                  <span class="table-col">经停信息</span>
                  <span class="table-col">计划发车时间</span>
                  <span class="table-col">司机签出时间</span>
                  <span class="table-col">计划到车时间</span>
                  <span class="table-col">司机签到时间</span>
                </li>
                <li v-for="(stop, i) in (formatData.stopList || [])" :key="i" class="table-row">
                  <span class="table-col">{{ stop.networkName }}</span>
                  <span class="table-col">{{ stop.plannedDepartureTime }}</span>
                  <span
                    class="table-col"
                    :class="getstopListMax(stop, 'actualDepartureTime')"
                  >{{ stop.actualDepartureTime }}</span>
                  <span class="table-col">{{ stop.plannedArrivalTime }}</span>
                  <span
                    class="table-col"
                    :class="getstopListMax(stop, 'actualArrivalTime')"
                  >{{ stop.actualArrivalTime }}</span>
                </li>
              </template>
            </ul>
          </section>
          <span :class="node.exceptionClass">{{ node.content }}</span>
        </el-tooltip>
        <span v-else :class="node.exceptionClass">{{ node.content }}</span>
      </section>
    </template>
  </div>
</template>
<script lang="js">
import { DICT } from '@/common/utils/dict'

export default {
  name: 'TrajectoryContent',
  props: {
    trackData: {
      type: Object,
      default: () => {}
    },
    markClassMap: {
      type: Object,
      default: () => {}
    },
    option: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      // 1. 网点显示字段：网点客服、联系方式
      // 2. 任务号显示字段：规划到达时间、预计到达时间、任务状态、实际到达时间
      // 3. 包号显示字段：建包名称、包内件总数
      // 4. 任务号异常：最新轨迹中的【任务号】 进行标红
      // 5. 扫描网点异常：仅最新扫描轨迹-扫描网点 信息标红
      // 6. 下一站异常：仅最新扫描轨迹-下一站网点 标红
      // 7. 判断是否异常需过滤的类型：问题件扫描、退件登记、退件扫描、拦截件登记、拦截件扫描、拦截件撤销、退件撤销
      parsedContent: [],
      shipmentState: DICT.shipmentState,
      formatData: {}
    }
  },
  computed: {
    tempalteMap() {
      return {
        '$[scanNetworkName]': {
          showTips: this.option.showNetInfo && this.formatData.scanNetworkName,
          comType: 'scanNetwork'
        },
        '$[nextStopName]': {
          showTips: this.option.showNetLast && this.formatData.nextStopName,
          comType: 'nextStop'
        },
        '$[packageNumber]': {
          showTips: this.option.showPackInfo && this.formatData.packageNumber,
          comType: 'package'
        },
        '$[remark2]': {
          showTips: (this.option.abnormalTask && this.formatData.isTask) || (this.option.showStopList && this.formatData.stopList),
          comType: 'task'
        }
      }
    }
  },
  watch: {
    trackData: {
      handler(val) {
        if (val) {
          this.formatData = { ...val }
          this.anomalyMark()
          this.parsedContent = this.parseText(val)
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    anomalyMark() {
      try {
        // 下一站网点异常
        if (this.tempalteMap['$[nextStopName]'].showTips && this.formatData.isLatestTrack && this.formatData.showNetLast && this.formatData.showNetLast.isAbnormal === 1) {
          const colorLabel = this.formatData.showNetLast && this.formatData.showNetLast.colorLabel
          this.tempalteMap['$[nextStopName]'].exceptionClass = this.markClassMap[colorLabel] || 'exception-class'
        }
      } catch (error) {
        console.log('下一站网点异常', error)
      }
      try {
        // 扫描网点异常
        if (this.tempalteMap['$[scanNetworkName]'].showTips && this.formatData.isLatestTrack && this.formatData.isAbnormal === 1) {
          this.tempalteMap['$[scanNetworkName]'].exceptionClass = this.markClassMap[this.formatData.colorLabel] || 'exception-class'
        }
      } catch (error) {
        console.log('扫描网点异常', error)
      }
      try {
        if (this.option.abnormalTask && this.formatData.isTask) {
          if (this.formatData.shipmentState) {
            this.formatData.shipmentStateDesc = this.shipmentState[this.formatData.shipmentState] && this.shipmentState[this.formatData.shipmentState].label
          }
          // 任务号异常
          if (this.formatData.abnormalSource === 2 && this.formatData.taskList) {
            this.tempalteMap['$[remark2]'].exceptionClass = this.markClassMap[1]
          }
        }
      } catch (error) {
        console.log('任务号异常', error)
      }
    },
    parseText(data) {
      const { template } = data || {}
      if (!template) {
        return [{
          type: 'text',
          content: data.waybillTrackingContent || ''
        }]
      }
      const parts = [];
      // const regex = new RegExp(Object.keys(this.tempalteMap).join('|').replace(/[\$\[\]]/g, '\\$&'), 'g')
      const regex = /\$\[[^\[\]]*?\]/g
      let lastIndex = 0;
      let match;

      while ((match = regex.exec(template))) {
        // 添加普通文本部分
        if (match.index > lastIndex) {
          parts.push({
            type: 'text',
            content: template.slice(lastIndex, match.index) || ''
          });
        }

        // 添加 tooltip 部分
        const matchKey = match[0]
        const key = matchKey.replace(/[\$\[\]]/g, '')
        const { showTips, comType, exceptionClass = '' } = this.tempalteMap[matchKey] || {}
        if (showTips) {
          parts.push({
            type: 'tooltip',
            content: this.formatData[key] || '',
            comType,
            exceptionClass
          });
        } else {
          parts.push({
            type: 'text',
            content: this.formatData[key] || '',
            exceptionClass
          });
        }

        lastIndex = regex.lastIndex;
      }

      // 添加剩余的普通文本部分
      if (lastIndex < template.length) {
        parts.push({
          type: 'text',
          content: template.slice(lastIndex) || ''
        });
      }
      return parts
    },
    getstopListMax(item, key) {
      const isMax = (s1, s2) => {
        const t1 = new Date(s1).getTime()
        const t2 = new Date(s2).getTime()
        return t2 > t1
      }
      const { plannedDepartureTime, actualDepartureTime, plannedArrivalTime, actualArrivalTime } = item
      if (key === 'actualDepartureTime' && plannedDepartureTime && actualDepartureTime) {
        return isMax(plannedDepartureTime, actualDepartureTime) ? 'text-red' : ''
      }
      if (key === 'actualArrivalTime' && plannedArrivalTime && actualArrivalTime) {
        return isMax(plannedArrivalTime, actualArrivalTime) ? 'text-red' : ''
      }
      return ''
    }
  }
}
</script>
<style lang="scss" scoped>
  .table-tip-wrap {
    width: 100%;
    max-height: 30vh;
    overflow-y: auto;
    ul, li {
      list-style: none;
      padding: 0;
      margin: 0;
    }
  }
  .table-tip {
    display: table;
    &.is-border-table {
      border-right: 1px solid;
      border-bottom: 1px solid;
      @include border-color('lighter');
      .table-row {
        .table-col {
          padding: 5px 10px;
          border-left: 1px solid;
          border-top: 1px solid;
          @include border-color('lighter');
        }
      }
    }
    .table-row {
      display: table-row;
      &:first-child {
        word-break: keep-all;
      }
      .table-col {
        display: table-cell;
      }
      .table-inner-cell {
        padding: 0 !important;
        & > div {
          word-break: keep-all;
          white-space: nowrap;
          overflow: hidden;
          padding: 0 5px;
          line-height: 30px;
          &:not(:first-child) {
            border-top: 1px solid;
            @include border-color('lighter');
          }
        }
      }
    }
  }
</style>
